export function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):not([name='updates[]']):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

/**
 * Progressively enhance links into buttons with JavaScript
 *
 * useful for things like a link to the cart page that can transform into a
 * toggle for the cart drawer when JS is present
 */
export function enhanceAnchorIntoButton(el, callback) {
  if (!el || !callback || typeof callback !== "function") return;

  el.addEventListener("click", () => callback());

  if (el.tagName === "BUTTON") return;

  el.removeAttribute("href");
  el.setAttribute("role", "button");
  el.setAttribute("tabindex", 0);
  // Use <button> key events (https://adrianroselli.com/2022/04/brief-note-on-buttons-enter-and-space.html)
  el.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    if (event.key !== "Enter") return;
    callback();
  });
  el.addEventListener("keyup", (event) => {
    if (event.key !== " ") return;
    event.preventDefault();
    callback();
  });
}
